<script>

import { layoutComputed } from "@/state/helpers";
import {logoutUser} from "../api/auth";
import {
  getSchoolToken,
  getUserData,
  removeModeratorToken,
  removeSchoolToken,
  removeUserData,
  setUserLang,
} from "../utils/auth";

/**
 * Horizontal-topbar component
 */
export default {
  computed: {
    ...layoutComputed,
    profile(){
      if(getUserData()) {
        let user = JSON.parse(getUserData())
        return getSchoolToken() ? user.director : user.name
      }
      else {
        return '';
      }
    },
  },
  components: {
  },
  data() {
    return {
      languages: [
        {
          flag:require("@/assets/images/flags/uz.jpg"),
          language: "uz",
          title:"UZ",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "EN",
        },
        {
          flag: require("@/assets/images/flags/russia.jpg"),
          language: "ru",
          title: "РУ"
        },
        {
          flag: require("@/assets/images/flags/karakalpak.png"),
          language: "kr",
          title: "KR"
        }
      ],
      current_language: this.$i18n.locale,
      text: null,
      flag: null,
      value: null,
    };
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === this.$i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  methods: {
    logoutTheUser() {
      logoutUser().then(() => {
        removeSchoolToken()
        removeModeratorToken()
        removeUserData()
        this.$router.push("/");
      })
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
          !document.fullscreenElement &&
          /* alternative standard method */ !document.mozFullScreenElement &&
          !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
              Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country) {
      this.current_language = locale;
      this.$i18n.locale = locale;
      this.text = country;
      setUserLang(locale);
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <header id="page-topbar" style="background-color: #185d89">
    <div class="navbar-header mt-5">
      <div class="d-flex ms-3">
        <!-- LOGO -->
        <router-link to="/" class="logo logo-dark ms-4">
            <span class="logo-sm">
              <img src="@/assets/images/mno-logo/client1.png" alt height="60" class="mb-5 mt-4" />
            </span>
          <span class="logo-lg">
              <img src="@/assets/images/mno-logo/client1.png" alt height="60" class="mb-5 mt-2" />
            </span>
        </router-link>

        <router-link to="/" class="logo logo-light ms-4">
            <span class="logo-sm">
              <img src="@/assets/images/mno-logo/client1.png" alt height="60" class="mb-5 mt-4" />
            </span>
          <span class="logo-lg">
              <img src="@/assets/images/mno-logo/client1.png" alt height="60" class="mb-5 mt-2" />
            </span>
        </router-link>
        <div class="mt-2 ms-3">
<!--          <h5 class="text-white">{{$t('message.UZB')}} <br> {{$t('message.MNO')}}</h5>-->
          <h4 class="text-white mb-5"> {{$t('MNO_title.MNO_web')}} <br>
            {{$t('MNO_title.Vakant')}} <br>
            {{$t('MNO_title.MNO_system')}}</h4>
        </div>
        <!--          <button-->
        <!--          id="toggle"-->
        <!--          type="button"-->
        <!--          class="btn btn-sm me-2 font-size-16 d-lg-none header-item"-->
        <!--          @click="toggleMenu"-->
        <!--        >-->
        <!--          <i class="fa fa-fw fa-bars"></i>-->
        <!--        </button>-->
      </div>

      <div class="d-flex">
        <!--        <b-dropdown-->
        <!--          class="d-inline-block d-lg-none ms-2"-->
        <!--          variant="black"-->
        <!--          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"-->
        <!--          toggle-class="header-item noti-icon"-->
        <!--          right-->
        <!--        >-->
        <!--          <template v-slot:button-content>-->
        <!--            <i class="mdi mdi-magnify"></i>-->
        <!--          </template>-->

        <!--          <form class="p-3">-->
        <!--            <div class="form-group m-0">-->
        <!--              <div class="input-group">-->
        <!--                <input-->
        <!--                  type="text"-->
        <!--                  class="form-control"-->
        <!--                  :placeholder="$t('message.Search')"-->
        <!--                  aria-label="Recipient's username"-->
        <!--                />-->
        <!--                <div class="input-group-append">-->
        <!--                  <button class="btn btn-primary" type="submit">-->
        <!--                    <i class="mdi mdi-magnify"></i>-->
        <!--                  </button>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </form>-->
        <!--        </b-dropdown>-->
        <b-button variant="warning" class="battun mt-4" style="margin-right:10px">
          <b-dropdown variant="white" right toggle-class="header-item" menu-class="dropdown-menu-end">
            <template v-slot:button-content class="w-100">
              <!--            <img class :src="flag" alt="Header Language" height="16" />-->
              <div style="color: #185d89">
                {{ text }}
              </div>
            </template>
            <b-dropdown-item
                class="notify-item"
                v-for="(entry, i) in languages"
                :key="`Lang${i}`"
                :value="entry"
                @click="setLanguage(entry.language, entry.title, entry.flag)"
                :class="{ active: current_language === entry.language }"
            >
              <img
                  :src="`${entry.flag}`"
                  alt="user-image"
                  class="me-1"
                  height="12"
              />
              <span class="align-middle">{{ entry.title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-button>
        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end" class="dropp">
          <template v-slot:button-content>
            <!--            <img-->
            <!--              class="rounded-circle header-profile-user"-->
            <!--              src="@/assets/images/users/avatar-1.jpg"-->
            <!--              alt="Header Avatar"-->
            <!--            />-->
            <b-avatar></b-avatar>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <div class="w-100 d-none d-xl-inline-block ms-1">
            {{profile}}
          </div>
          <!-- item-->
          <a
              class="dropdown-item text-danger"
              @click="logoutTheUser"
          >
            <i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("message.Logout") }}
          </a>
        </b-dropdown>
        <!--        <b-dropdown right variant="black" toggle-class="header-item">-->
        <!--          <template v-slot:button-content>-->
        <!--            <img-->
        <!--              class="rounded-circle header-profile-user"-->
        <!--              src="@/assets/images/users/avatar-1.jpg"-->
        <!--              alt="Header Avatar"-->
        <!--            />-->
        <!--            <span class="d-none d-xl-inline-block ms-1">{{-->
        <!--              $t("navbar.dropdown.henry.text")-->
        <!--            }}</span>-->
        <!--            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>-->
        <!--          </template>-->
        <!--          &lt;!&ndash; item&ndash;&gt;-->
        <!--          <a href="/logout" class="dropdown-item text-danger">-->
        <!--            <i-->
        <!--              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"-->
        <!--            ></i>-->
        <!--            {{ $t("navbar.dropdown.henry.list.logout") }}-->
        <!--          </a>-->
        <!--        </b-dropdown>-->

      </div>
    </div>
  </header>
</template>

<style scoped>
.battun{
  width: 40px;
  height: 30px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  border-radius: 0;
}
.navbar-header{
  height: 85px;
}
.text-white{
  font-size: 17px;
}
.dropp {

  margin-bottom: 50px;
}
a{
  cursor: pointer;
}
</style>
